import { CollectionAction } from '../collection-action.interface';
import { CollectionAsset } from '../collection-asset';
import { CollectionState } from '../collection-state.interface';
import { isMatchingAsset } from '../is-matching-asset';

const onRemoveAssetRequest = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => ({
  ...state,
  listOfCollections: state.listOfCollections.map((collection) => {
    if (collection.collectionId === action.collectionId) {
      const newAssets = collection.assets.filter(
        (aAsset) => !(action.assets as CollectionAsset[]).find(
          isMatchingAsset(aAsset),
        ),
      );

      return {
        ...collection,
        assets: newAssets,
        count: newAssets.length,
      };
    }

    return collection;
  }),
});

export default onRemoveAssetRequest;
